/* ═══════════ SHOPIFY FIXES ═══════════ */
(function(){
  var IMG_URL='https://cdn.shopify.com/s/files/1/0965/9813/1028/files/image.png?v=1781188916';

  var h=document.querySelector('#shopify-section-header,[id^="shopify-section-header"],[id^="shopify-section-sections--"][id*="header"]');
  if(!h){
    var secs=document.querySelectorAll('[id^="shopify-section"]');
    for(var i=0;i<secs.length;i++){
      if(secs[i].querySelector('header,nav,.header-wrapper,.header__wrapper,.header__heading')){h=secs[i];break}
    }
  }
  if(h){h.style.position='relative';h.style.zIndex='10001'}
  var ab=document.querySelector('[id^="shopify-section"][id*="announcement"],[id^="shopify-section-sections--"][id*="announcement"]');
  if(ab){ab.style.position='relative';ab.style.zIndex='10002'}

  var bgfx=document.getElementById('bgfx');
  if(bgfx&&bgfx.parentElement!==document.body){document.body.insertBefore(bgfx,document.body.firstChild)}
  var ld=document.getElementById('ld');
  if(ld&&ld.parentElement!==document.body){document.body.insertBefore(ld,bgfx?bgfx.nextSibling:document.body.firstChild)}

  var portal=document.getElementById('portal');
  if(portal&&portal.parentElement!==document.body){document.body.appendChild(portal)}
  var pop=document.getElementById('pop');
  if(pop&&pop.parentElement!==document.body){document.body.appendChild(pop)}

  var bg=document.getElementById('bg-img');
  if(bg){
    if(!bg.src||bg.src==='')bg.src=IMG_URL;
    bg.style.position='absolute';bg.style.inset='-4%';bg.style.objectFit='cover';
    bg.style.filter='brightness(.6) saturate(1.06)';bg.style.width='108%';bg.style.height='108%';bg.style.display='block';
  }

  var root=document.getElementById('amk200k-root');
  var sec=root?root.closest('.shopify-section,[id^="shopify-section"]'):document.querySelector('.amk-300k-section');
  if(sec){
    sec.style.cssText+=';position:relative!important;z-index:1!important;background:transparent!important;overflow:visible!important;contain:none!important;transform:none!important;will-change:auto!important;filter:none!important;perspective:none!important;backdrop-filter:none!important;isolation:auto!important';
    var el=sec.parentElement;
    while(el&&el!==document.body&&el!==document.documentElement){
      el.style.background='transparent';el.style.backgroundColor='transparent';
      el.style.contain='none';el.style.transform='none';el.style.filter='none';
      el.style.isolation='auto';el.style.perspective='none';
      el=el.parentElement;
    }
  }

  document.body.style.background="#070303 url('"+IMG_URL+"') center/cover fixed no-repeat";
})();

/* ═══════════ API ═══════════ */
var API='https://script.google.com/macros/s/AKfycbyRqUv4nyDv2WRfV1NBBOJBo2bGN3fO0tc3xOYrhGgGHJlRBfEn3BQCp_8So6i-dEMo/exec';
function vEmail(e){return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(e||'').trim())}

/* ═══════════ 3D SCROLL STAGE ═══════════ */
function initStage(){
  if(typeof gsap==='undefined')return;
  gsap.registerPlugin(ScrollTrigger);
  var banner=document.getElementById('l-banner'),heli=document.getElementById('l-heli'),boeing=document.getElementById('l-boeing'),
      jet=document.getElementById('l-jet'),bus=document.getElementById('l-bus'),ticket=document.getElementById('l-ticket'),
      smoke=document.getElementById('heli-smoke'),trail=document.getElementById('jet-trail');

  var mob=window.innerWidth<680;
  gsap.set(banner,{xPercent:-50,yPercent:-50,x:'0vw',  y:mob?'-12vh':'-4vh', scale:mob?.88:1.05,opacity:1,rotation:0,z:0});
  gsap.set(boeing,{xPercent:-50,yPercent:-50,x:mob?'0vw':'2vw',  y:mob?'-32vh':'-26vh',scale:mob?.38:.68,opacity:1,rotation:-3});
  gsap.set(jet,   {xPercent:-50,yPercent:-50,x:mob?'26vw':'32vw', y:mob?'-16vh':'-12vh',scale:mob?.3:.52,opacity:1,rotation:10});
  gsap.set(heli,  {xPercent:-50,yPercent:-50,x:mob?'-26vw':'-34vw',y:mob?'-10vh':'-4vh', scale:mob?.36:.58, opacity:1,rotation:-8});
  gsap.set(bus,   {xPercent:-50,yPercent:-50,x:'-5vw', y:'20vh', scale:.36,opacity:0,rotation:0});
  gsap.set(ticket,{xPercent:-50,yPercent:-50,x:'34vw', y:'18vh', scale:.34,opacity:0,rotation:7});

  var scr=mob?0.8:1.2;
  if(mob){
    gsap.fromTo('#bg-img',{scale:1.0,filter:'brightness(.55) saturate(1.08)'},
      {scale:1.08,filter:'brightness(.2) saturate(.95)',ease:'none',
       scrollTrigger:{trigger:'body',start:'top top',end:'bottom bottom',scrub:scr}});
  }else{
    gsap.fromTo('#bg-img',{scale:1.0,filter:'brightness(.55) saturate(1.08) blur(0px)'},
      {scale:1.16,filter:'brightness(.16) saturate(.95) blur(7px)',ease:'none',
       scrollTrigger:{trigger:'body',start:'top top',end:'bottom bottom',scrub:scr}});
  }
  gsap.fromTo('#bg-veil',{opacity:.35},{opacity:.92,ease:'none',scrollTrigger:{trigger:'body',start:'top top',end:'60% bottom',scrub:scr}});
  
if(mob){
  gsap.set('#bg-img',{
    filter:'brightness(.45) saturate(1.02)'
  });

  tl = gsap.timeline({
    scrollTrigger:{
      trigger:'#stage',
      start:'top top',
      end:'+=2200',
      pin:true,
      scrub:0.35,
      anticipatePin:1,
      pinSpacing:true
    }
  });
}else{
  tl = gsap.timeline({
    scrollTrigger:{
      trigger:'#stage',
      start:'top top',
      end:'+=5600',
      pin:true,
      scrub:1.2,
      anticipatePin:1
    }
  });
}
  /* A1 */
  tl.addLabel('a1')
    .to('#hero-panel',{opacity:0,y:-30,scale:.92,duration:.3,ease:'power2.in'},'a1')
    .to('#stage-scroll',{opacity:0,duration:.2},'a1')
    .to(banner,{y:'-46vh',scale:.32,opacity:.35,duration:1,ease:'power2.inOut'},'a1')
    .to([boeing,jet,bus,ticket],{y:'-130vh',opacity:0,scale:.2,duration:.9,stagger:.04,ease:'power2.in'},'a1')
    .fromTo(heli,{x:mob?'-26vw':'-34vw',y:mob?'-10vh':'-4vh',scale:mob?.36:.58,rotation:-8,opacity:1},{x:'0vw',y:mob?'-14vh':'-2vh',scale:mob?.8:1,rotation:0,opacity:1,duration:1.1,ease:'expo.out'},'a1')
    .to(heli,{y:'+=2vh',duration:.5,ease:'sine.inOut'},'a1+=1.0')
    .to(smoke,{opacity:1,scale:1.08,duration:.7,ease:'power1.out'},'a1+=.35')
    .fromTo('#cap-1',{opacity:0,y:60,filter:mob?'none':'blur(6px)'},{opacity:1,y:0,filter:'none',duration:.55,ease:'power3.out'},'a1+=.65');

  /* A2 */
  tl.addLabel('a2','+=.6')
    .to('#cap-1',{opacity:0,y:-46,filter:mob?'none':'blur(6px)',duration:.4,ease:'power2.in'},'a2')
    .to(smoke,{opacity:0,duration:.4},'a2')
    .to(heli,{y:'-105vh',scale:1.2,opacity:0,rotation:12,duration:1,ease:'power3.in'},'a2')
    .fromTo(boeing,{x:'-120vw',y:'4vh',scale:.85,rotation:-12,opacity:0},{x:'0vw',y:mob?'-14vh':'-6vh',scale:mob?.72:.88,rotation:0,opacity:1,duration:1.15,ease:'expo.out',immediateRender:false},'a2+=.15')
    .to(boeing,{rotation:2,duration:.5,ease:'sine.inOut'},'a2+=1.2').to(boeing,{rotation:0,duration:.5,ease:'sine.inOut'},'a2+=1.7')
    .fromTo('#cap-2',{opacity:0,y:60,filter:mob?'none':'blur(6px)'},{opacity:1,y:0,filter:'none',duration:.55,ease:'power3.out'},'a2+=.8');

  /* A3 */
  tl.addLabel('a3','+=.6')
    .to('#cap-2',{opacity:0,y:-46,filter:mob?'none':'blur(6px)',duration:.4,ease:'power2.in'},'a3')
    .to(boeing,{x:'115vw',y:'-30vh',scale:1.4,rotation:16,opacity:0,duration:.95,ease:'power3.in'},'a3')
    .set(trail,{opacity:0},'a3')
    .fromTo(jet,{x:'110vw',y:'80vh',scale:.42,rotation:20,opacity:0},{x:mob?'0vw':'-4vw',y:mob?'-14vh':'-2vh',scale:mob?.85:1.06,rotation:-10,opacity:1,duration:.95,ease:'expo.out',immediateRender:false},'a3+=.15')
    .to(trail,{opacity:.8,duration:.35},'a3+=.2').to(trail,{opacity:0,duration:.5},'a3+=.7')
    .to(jet,{x:'0vw',y:mob?'-12vh':'1vh',rotation:-2,scale:mob?.82:1.02,duration:.6,ease:'back.out(1.4)'},'a3+=.95')
    .fromTo('#cap-3',{opacity:0,y:60,filter:mob?'none':'blur(6px)'},{opacity:1,y:0,filter:'none',duration:.55,ease:'power3.out'},'a3+=1.0');

  /* A4 */
  tl.addLabel('a4','+=.6')
    .to('#cap-3',{opacity:0,y:-46,filter:mob?'none':'blur(6px)',duration:.4,ease:'power2.in'},'a4')
    .to(jet,{x:'-30vw',y:'-26vh',scale:1.2,rotation:10,opacity:0,duration:.85,ease:'power3.in'},'a4')
    .fromTo(bus,{x:'120vw',y:'6vh',scale:.7,opacity:0},{x:'0vw',y:mob?'-12vh':'2vh',scale:mob?.82:1.04,opacity:1,duration:1.05,ease:'expo.out',immediateRender:false},'a4+=.15')
    .fromTo('#cap-4',{opacity:0,y:60,filter:mob?'none':'blur(6px)'},{opacity:1,y:0,filter:'none',duration:.55,ease:'power3.out'},'a4+=.7');

  /* A5 */
  tl.addLabel('a5','+=.6')
    .to('#cap-4',{opacity:0,y:-46,filter:mob?'none':'blur(6px)',duration:.4,ease:'power2.in'},'a5')
    .to(bus,{x:'-120vw',y:'4vh',scale:.8,opacity:0,duration:.9,ease:'power3.in'},'a5')
    .fromTo(ticket,{x:'0vw',scale:.3,y:'4vh',opacity:0,rotation:-12},{x:'0vw',scale:mob?.85:1,y:mob?'-16vh':'-6vh',opacity:1,rotation:0,duration:.9,ease:'back.out(1.6)',immediateRender:false},'a5+=.15')
    .to(ticket,{rotation:4,duration:.5,ease:'sine.inOut'},'a5+=1.05').to(ticket,{rotation:0,duration:.5,ease:'sine.inOut'},'a5+=1.55')
    .fromTo('#cap-5',{opacity:0,y:60,filter:mob?'none':'blur(6px)'},{opacity:1,y:0,filter:'none',duration:.55,ease:'power3.out'},'a5+=.5');

  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('vis');io.unobserve(e.target)}})},{threshold:.1,rootMargin:'0px 0px -8% 0px'});
    document.querySelectorAll('.rv').forEach(function(el){io.observe(el)});
  }else document.querySelectorAll('.rv').forEach(function(el){el.classList.add('vis')});

  var imgs=document.querySelectorAll('#stage img');var L=0;
  imgs.forEach(function(im){if(im.complete)L++;else im.addEventListener('load',function(){L++;if(L>=imgs.length)ScrollTrigger.refresh()})});
  ScrollTrigger.refresh();
}
var _staged=false;function bootStage(){if(_staged)return;_staged=true;try{initStage()}catch(e){console.error(e)}}
function hideLoader(){var l=document.getElementById('ld');if(l)l.classList.add('out')}
if(document.readyState!=='loading')bootStage();else document.addEventListener('DOMContentLoaded',bootStage);
window.addEventListener('load',function(){bootStage();if(typeof ScrollTrigger!=='undefined')ScrollTrigger.refresh();setTimeout(hideLoader,1800)});
setTimeout(hideLoader,3200);

/* ═══════════ COUNTDOWN (zum Giveaway-Ende 15.09) ═══════════ */
(function(){
  var END=new Date('2026-09-14T23:59:00');
  var d=document.getElementById('cd-d'),h=document.getElementById('cd-h'),mi=document.getElementById('cd-m'),s=document.getElementById('cd-s'),lsDays=document.getElementById('ls-days');
  function pad(n){return (n<10?'0':'')+n}
  function tick(){var diff=END-new Date();if(diff<0)diff=0;
    var days=Math.floor(diff/864e5),hrs=Math.floor(diff%864e5/36e5),mins=Math.floor(diff%36e5/6e4),secs=Math.floor(diff%6e4/1e3);
    if(d)d.textContent=pad(days);if(h)h.textContent=pad(hrs);if(mi)mi.textContent=pad(mins);if(s)s.textContent=pad(secs);if(lsDays)lsDays.textContent=days}
  tick();setInterval(tick,1000);
})();

/* ═══════════ LIVE STATS count-up ═══════════ */
(function(){
  var els=document.querySelectorAll('.stat-num[data-count]');if(!els.length||!('IntersectionObserver' in window))return;
  var io=new IntersectionObserver(function(ents){ents.forEach(function(e){if(!e.isIntersecting)return;io.unobserve(e.target);
    var el=e.target,target=+el.getAttribute('data-count'),suf=el.getAttribute('data-suffix')||'',st=performance.now(),dur=1600;
    requestAnimationFrame(function f(n){var p=Math.min((n-st)/dur,1),ease=1-Math.pow(1-p,3);el.textContent=Math.floor(ease*target).toLocaleString('de-DE')+suf;if(p<1)requestAnimationFrame(f);else el.textContent=target.toLocaleString('de-DE')+suf})
  })},{threshold:.4});
  els.forEach(function(el){io.observe(el)});
})();

/* ═══════════ DEPOSIT (1€ = 1 Ticket) ═══════════ */
function pmsg(id,t,c){var el=document.getElementById(id);if(el){el.textContent=t;el.className='pmsg '+c}}
(function(){var inp=document.getElementById('dep-amount');if(!inp)return;inp.addEventListener('input',function(){
  var v=parseInt(this.value,10)||0,prev=document.getElementById('dep-preview'),tprev=document.getElementById('dep-tickets-preview');
  if(v>=20){prev.style.display='block';tprev.textContent=v.toLocaleString('de-DE')+' Tickets'}else{prev.style.display='none'}})})();
function doDeposit(e){e.preventDefault();var f=document.getElementById('sf');var sess=getSess();if(!sess){pmsg('s-msg','Bitte anmelden.','err');return}
  var cas=(f.querySelector('[name="casino"]')||{}).value||'';
  var amt=parseInt(document.getElementById('dep-amount').value,10)||0;
  if(!cas){pmsg('s-msg','Bitte Casino auswählen.','err');return}if(amt<20){pmsg('s-msg','Mindesteinzahlung: 20€.','err');return}if(!document.getElementById('tc').checked){pmsg('s-msg','Bitte bestätigen.','err');return}
  pmsg('s-msg','Wird gespeichert…','inf');var btn=f.querySelector('button[type="submit"]');btn.disabled=true;
  fetch(API,{method:'POST',headers:{'Content-Type':'text/plain;charset=utf-8'},body:JSON.stringify({action:'deposit',email:sess.email,casino:cas.trim(),amount:amt,name:sess.un||sess.name})})
    .then(function(r){return r.json().catch(function(){return{}})}).then(function(d){btn.disabled=false;if(d&&d.status==='success'){pmsg('s-msg',amt+'€ eingetragen — '+amt+' Tickets erhalten ✓','ok');popOpen('Einzahlung erfolgreich!','<span>'+amt+' Tickets</span> erhalten!','Casino: '+d.casino+' · Gesamt: '+d.totalTickets+' Tickets');document.getElementById('dep-amount').value='';document.getElementById('dep-preview').style.display='none';loadDashboard(sess.email)}else pmsg('s-msg',d&&d.message||'Fehler. Nochmals versuchen.','err')})
    .catch(function(){btn.disabled=false;pmsg('s-msg','Verbindung fehlgeschlagen.','err')})}
function loadStatus(){var sess=getSess();if(!sess)return;var el=document.getElementById('status-info');el.textContent='Wird geladen…';
  fetch(API,{method:'POST',headers:{'Content-Type':'text/plain;charset=utf-8'},body:JSON.stringify({action:'check',email:sess.email})})
    .then(function(r){return r.json().catch(function(){return{}})}).then(function(d){if(d&&d.status==='success'&&d.hasDeposits&&d.deposits.length){
      var h='<div style="margin-bottom:16px;font-family:Outfit;font-weight:800;font-size:1.1rem;color:var(--gold)">'+d.totalTickets.toLocaleString('de-DE')+' Tickets · '+d.totalDeposits.toLocaleString('de-DE')+'€</div>';
      h+='<div style="display:flex;flex-direction:column;gap:8px">';
      d.deposits.forEach(function(dep){h+='<div style="display:flex;justify-content:space-between;align-items:center;padding:10px 14px;border-radius:10px;background:rgba(255,255,255,.04);border:1px solid var(--line)"><div><b style="color:var(--text);font-size:.82rem">'+dep.casino+'</b><div style="font-size:.68rem;color:var(--muted2)">'+dep.date+'</div></div><div style="text-align:right"><b style="color:var(--gold);font-size:.88rem">'+dep.amount+'€</b><div style="font-size:.62rem;color:var(--muted2)">'+dep.tickets+' Tickets · '+dep.status+'</div></div></div>'});
      h+='</div>';el.innerHTML=h}else el.innerHTML='<div style="font-size:2.4rem;margin-bottom:12px">—</div><div style="font-family:Outfit;font-weight:800;font-size:1rem;margin-bottom:6px">Noch keine Einzahlung</div><div style="color:var(--muted);font-size:.82rem">Zahle über einen Partner-Link ein und trage es hier ein!</div>'})
    .catch(function(){el.textContent='Verbindung fehlgeschlagen.'})}

/* ═══════════ TABS ═══════════ */
function pPane(name){document.querySelectorAll('.ppane').forEach(function(p){p.classList.remove('on')});document.getElementById('pane-'+name).classList.add('on')}

/* ═══════════ AUTH ═══════════ */
var SKEY='amk_sess';
function getSess(){return JSON.parse(sessionStorage.getItem(SKEY)||'null')}
function setSess(u){sessionStorage.setItem(SKEY,JSON.stringify(u))}
function clearSess(){sessionStorage.removeItem(SKEY)}
function openAuth(t){document.getElementById('auth-modal').classList.add('on');amTab(t||'l');document.body.style.overflow='hidden'}
function closeAuth(){document.getElementById('auth-modal').classList.remove('on');document.body.style.overflow=''}
function amTab(t){document.getElementById('lform').style.display=t==='l'?'block':'none';document.getElementById('rform').style.display=t==='r'?'block':'none';document.getElementById('amt-l').classList.toggle('on',t==='l');document.getElementById('amt-r').classList.toggle('on',t==='r')}
function fmsg(id,t,c){var el=document.getElementById(id);if(el){el.textContent=t;el.className='amsg '+c}}
function doLogin(e){e.preventDefault();var em=document.getElementById('l-em').value.trim().toLowerCase(),pw=document.getElementById('l-pw').value;
  if(!em||!pw){fmsg('l-msg','Alle Felder ausfüllen.','err');return}
  fmsg('l-msg','Wird geprüft…','inf');
  fetch(API,{method:'POST',headers:{'Content-Type':'text/plain;charset=utf-8'},body:JSON.stringify({action:'login',email:em,password:pw})})
    .then(function(r){return r.json().catch(function(){return{}})}).then(function(d){if(d&&d.status==='success'){fmsg('l-msg','Willkommen! ✓','ok');var s={email:em,name:d.name,un:d.username};setSess(s);setTimeout(function(){closeAuth();openPortal(s)},500)}else fmsg('l-msg',d&&d.message||'Login fehlgeschlagen.','err')})
    .catch(function(){fmsg('l-msg','Verbindung fehlgeschlagen.','err')})}
function doReg(e){e.preventDefault();var fn=document.getElementById('r-fn').value.trim(),un=document.getElementById('r-un').value.trim(),em=document.getElementById('r-em').value.trim().toLowerCase(),pw=document.getElementById('r-pw').value;
  if(!fn||!un||!em||!pw){fmsg('r-msg','Alle Felder ausfüllen.','err');return}if(!vEmail(em)){fmsg('r-msg','Ungültige E-Mail.','err');return}if(pw.length<6){fmsg('r-msg','Passwort min. 6 Zeichen.','err');return}if(!document.getElementById('r-terms').checked){fmsg('r-msg','Bitte AGB akzeptieren.','err');return}
  fmsg('r-msg','Wird registriert…','inf');
  fetch(API,{method:'POST',headers:{'Content-Type':'text/plain;charset=utf-8'},body:JSON.stringify({action:'register',email:em,password:pw,name:fn,username:un})})
    .then(function(r){return r.json().catch(function(){return{}})}).then(function(d){if(d&&d.status==='success'){var s={email:em,name:fn,un:un};setSess(s);fmsg('r-msg','Account erstellt ✓','ok');setTimeout(function(){closeAuth();openPortal(s)},500)}else fmsg('r-msg',d&&d.message||'Registrierung fehlgeschlagen.','err')})
    .catch(function(){fmsg('r-msg','Verbindung fehlgeschlagen.','err')})}
function openPortal(s){document.getElementById('portal').classList.add('on');document.body.style.overflow='hidden';
  document.getElementById('pt-name').textContent=s.un||s.name;document.getElementById('pt-email').textContent=s.email;
  document.getElementById('pt-av').textContent=(s.un||s.name||'A').charAt(0).toUpperCase();loadDashboard(s.email)}
function doLogout(){clearSess();document.getElementById('portal').classList.remove('on');document.body.style.overflow=''}
function loadDashboard(email){fetch(API,{method:'POST',headers:{'Content-Type':'text/plain;charset=utf-8'},body:JSON.stringify({action:'check',email:email})})
  .then(function(r){return r.json().catch(function(){return{}})}).then(function(d){if(d&&d.status==='success'&&d.hasDeposits){
    document.getElementById('ps-tick').textContent=d.totalTickets.toLocaleString('de-DE');
    document.getElementById('ps-tick-sub').textContent=d.totalDeposits.toLocaleString('de-DE')+'€ eingezahlt';
    document.getElementById('ps-deposits').textContent=d.totalDeposits.toLocaleString('de-DE')+'€';
    document.getElementById('ps-count').textContent=d.depositCount;
    document.getElementById('ps-stat').textContent='✓ Aktiv';document.getElementById('ps-stat').style.color='#34d399';
  }else{document.getElementById('ps-tick').textContent='0';document.getElementById('ps-tick-sub').textContent='Noch keine Einzahlung';
    document.getElementById('ps-deposits').textContent='0€';document.getElementById('ps-count').textContent='0';
    document.getElementById('ps-stat').textContent='Offen';document.getElementById('ps-stat').style.color=''}}).catch(function(){})}
(function(){var s=getSess();if(s)setTimeout(function(){openPortal(s)},1800)})();

/* ═══════════ POPUP ═══════════ */
function popOpen(t,hl,meta){document.getElementById('pop-t').textContent=t;document.getElementById('pop-hl').innerHTML=hl;document.getElementById('pop-meta').textContent=meta;document.getElementById('pop').classList.add('on')}
function popClose(){document.getElementById('pop').classList.remove('on')}
document.addEventListener('keydown',function(e){if(e.key==='Escape'){popClose();closeAuth()}});


/* ═══════════ FLOATING GOLD PARTICLES (desktop only) ═══════════ */
(function(){
  if(window.innerWidth<680)return;
  var c=document.getElementById('particles-canvas');if(!c)return;
  var ctx=c.getContext('2d'),ps=[],N=32;
  function resize(){c.width=window.innerWidth;c.height=window.innerHeight}
  resize();window.addEventListener('resize',resize);
  for(var i=0;i<N;i++)ps.push({x:Math.random()*c.width,y:Math.random()*c.height,r:Math.random()*1.2+.3,
    dx:(Math.random()-.5)*.22,dy:-(Math.random()*.35+.08),o:Math.random()*.35+.08,ph:Math.random()*6.28});
  (function draw(){
    ctx.clearRect(0,0,c.width,c.height);var t=Date.now()*.001;
    for(var i=0;i<ps.length;i++){var p=ps[i];
      p.x+=p.dx+Math.sin(t+p.ph)*.1;p.y+=p.dy;
      if(p.y<-10){p.y=c.height+10;p.x=Math.random()*c.width}
      if(p.x<-10)p.x=c.width+10;if(p.x>c.width+10)p.x=-10;
      var a=p.o*(.5+.5*Math.sin(t*1.2+p.ph));
      ctx.beginPath();ctx.arc(p.x,p.y,p.r,0,6.28);ctx.fillStyle='rgba(255,199,58,'+a+')';ctx.fill();
      ctx.beginPath();ctx.arc(p.x,p.y,p.r*3.5,0,6.28);ctx.fillStyle='rgba(255,199,58,'+(a*.1)+')';ctx.fill();
    }requestAnimationFrame(draw)})();
})();

/* ═══════════ CURSOR GLOW ═══════════ */
(function(){
  if(!window.matchMedia('(hover:hover)').matches)return;
  var g=document.getElementById('cursor-glow');if(!g)return;
  var cx=0,cy=0,tx=0,ty=0;
  document.addEventListener('mousemove',function(e){tx=e.clientX;ty=e.clientY;g.style.opacity='1'});
  document.addEventListener('mouseleave',function(){g.style.opacity='0'});
  (function u(){cx+=(tx-cx)*.065;cy+=(ty-cy)*.065;g.style.left=cx+'px';g.style.top=cy+'px';requestAnimationFrame(u)})();
})();

/* ═══════════ SCROLL PROGRESS ═══════════ */
(function(){
  var b=document.getElementById('scroll-prog');if(!b)return;
  window.addEventListener('scroll',function(){var h=document.documentElement.scrollHeight-window.innerHeight;
    b.style.transform='scaleX('+(h>0?window.scrollY/h:0)+')'},{ passive:true});
})();